import { Civility } from '@eogile/agrements-common/src/common-types/civilityTypes';

export const pmuCivilityLabels: Record<Civility, string> = {
  [Civility.MR]: 'M.',
  [Civility.MS]: 'Mme',
};
